var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#25272C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C30.6094 12 36 17.3906 36 24C36 30.6562 30.6094 36 24 36C17.3438 36 12 30.6562 12 24C12 17.3906 17.3438 12 24 12ZM24 33.75C29.3438 33.75 33.75 29.3906 33.75 24C33.75 18.6562 29.3438 14.25 24 14.25C18.6094 14.25 14.25 18.6562 14.25 24C14.25 29.3906 18.6094 33.75 24 33.75ZM24 27.75C24.7969 27.75 25.5 28.4062 25.5 29.25C25.5 30.0938 24.7969 30.75 24 30.75C23.1094 30.75 22.5 30.0938 22.5 29.25C22.5 28.4062 23.1562 27.75 24 27.75ZM25.5469 18C27.4219 18 28.875 19.4531 28.8281 21.2812C28.8281 22.4062 28.2188 23.4844 27.2344 24.0938L25.125 25.4062V25.5C25.125 26.1094 24.6094 26.625 24 26.625C23.3906 26.625 22.875 26.1094 22.875 25.5V24.75C22.875 24.375 23.0625 24 23.4375 23.7656L26.1094 22.1719C26.4375 21.9844 26.625 21.6562 26.625 21.2812C26.625 20.7188 26.1094 20.25 25.5 20.25H23.1094C22.5469 20.25 22.125 20.7188 22.125 21.2812C22.125 21.8906 21.6094 22.4062 21 22.4062C20.3906 22.4062 19.875 21.8906 19.875 21.2812C19.875 19.4531 21.3281 18 23.1562 18H25.5469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMobileIcon);
export default __webpack_public_path__ + "static/media/infoMobileIcon.9a4306fb9ec162045b193a218d5aa7eb.svg";
export { ForwardRef as ReactComponent };